<template>
  <div class="fukuanxiangqing">
    <div class="fukuan">
      <ul class="left">
        <!-- <li><span>商品订单：</span>{{ orderInfo.id }}</li> -->
        <li>
          <span>支付金额：</span><strong>￥{{ orderInfo.price }}</strong>
        </li>
      </ul>
      <ul class="right">
        <span>订单详情：</span>
        <li>缴费名称：{{ orderInfo.title }}</li>
        <!-- <li>支付订单：{{ orderInfo.id }}</li> -->
        <li>应付金额：￥{{ orderInfo.price }}</li>
      </ul>
      <div class="zhifufangshi">
        <span>支付方式：</span>
        <ul>
          <li
            :class="{ hit: payInfo.payType == 'B2C-JSAPI-WECHAT' }"
            @click="changePayType('B2C-JSAPI-WECHAT')"
          >
            <img src="@/assets/images/weixin.jpg" /><span>微信支付</span
            ><img src="@/assets/images/xuanze.jpg" class="xuanze" />
          </li>
          <li
            :class="{ hit: payInfo.payType == 'B2C-JSAPI-ALIPAY' }"
            @click="changePayType('B2C-JSAPI-ALIPAY')"
          >
            <img src="@/assets/images/zhifubao.jpg" /><span>支付宝支付</span
            ><img src="@/assets/images/xuanze.jpg" class="xuanze" />
          </li>
        </ul>

        <div id="qrcode" ref="qrcode" class="erweima" style="margin-top: 60px"></div>
        <!-- <img :src="payResult.qrcode" class="erweima" style="margin-top: 60px" /> -->
        <img
          src="@/assets/images/paytype1_demo.jpg"
          class="erweima"
          v-if="payInfo.payType == 'B2C-JSAPI-WECHAT'"
        />
        <img src="@/assets/images/paytype2_demo.jpg" class="erweima" v-else />
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      payTypeIndex: 0,
      payInfo: {
        noticeId: "",
        payType: "",
        enrollId: "",
      },
      orderInfo: {},
      payResult: {},
      timer: null,
      enrollId: "",
    };
  },
  created() {
    let _this = this;
    if (_this.$route.query.id) {
      _this.payInfo.noticeId = _this.$route.query.id;
      _this.getNoticeInfo();
    }
    if (_this.$route.query.enrollId) {
      _this.enrollId = _this.$route.query.enrollId;
      _this.payInfo.enrollId = _this.$route.query.enrollId;
    }
    this.$once("hook:beforeDestroy", () => {
      clearTimeout(_this.timer);
    });
  },
  methods: {
    changePayType(payType) {
      let _this = this;
      _this.payInfo.payType = payType;
      _this.orderPay();
    },
    getNoticeInfo() {
      let _this = this;
      let parmas = {
        id: _this.payInfo.noticeId,
      };
      _this.$api.recruitNotice
        .getRecruitNoticeDetail(parmas)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.orderInfo = res.data;
          } else {
            _this.$layer.alert(res.errorMsg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },

    orderPay() {
      let _this = this;
      _this.$api.pay
        .pay(_this.payInfo)
        .then((res) => {
          console.log('res',res)
          document.getElementById("qrcode").innerHTML = "";
          if (res.code == this.$commons.RespCode.success) {
            _this.payResult = res.data;
            let qrcode = new QRCode("qrcode", {
              width: 200, //图像宽度
              height: 200, //图像高度
              colorDark: "#000000", //前景色
              colorLight: "#ffffff", //背景色
              typeNumber: 4,
              correctLevel: QRCode.CorrectLevel.H, //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
            });
            qrcode.clear(); //清除二维码
            qrcode.makeCode(
              // "http://yunbanktest.bankcomm.com/tcipp/pmss/cipp.jsp?qrCode=" +
              res.data.rsp_body.redirect_url
            ); //生成另一个新的二维码
            _this.query();
          } else {
            _this.payResult = {};
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    query() {
      let _this = this;
      let params = {
        merTranNo: _this.payResult.rsp_body.pay_mer_tran_no,
        enrollId: _this.enrollId,
      };
      if (_this.timer){
        clearTimeout(_this.timer);
      }
      _this.timer = setTimeout(function () {
        _this.$api.pay
          .payResult(params)
          .then((res) => {
            if (res.data == 1) {
              clearTimeout(_this.timer);
              _this.$layer.alert("支付成功", { icon: 1, closeBtn: 0 }, function (index) {
                window.history.go(-1);
                _this.$layer.close(index);
              });
            } else if (res.data == -1) {
              clearTimeout(_this.timer);
              _this.$layer.alert("支付失败", function (index) {
                _this.$layer.close(index);
              });
            } else {
              _this.query();
            }
          })
          .catch(() => {})
          .finally(() => {});
      }, 1000);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/view/pay/pay.vue